import React, { Component } from 'react'
import { Link } from 'react-router'
import Tappable from 'react-tappable'

import classNames from './AlbumList.css'
import Icon from '../Icon'

const LIMIT_ALBUMS = 10
const PRESS_DELAY = 500

export default class AlbumList extends Component {
  renderAlbum = album => {
    if (!album) return null
    const { getImageSource, getAlbumInfo, isFavourite, viewAlbum, editAlbum } = this.props
    const structure = JSON.parse(album.json_data)
    const fixed = structure.fixed && structure.fixed.length !== 0
    return (
      <Tappable key={album.id} onTap={() => viewAlbum(album.id)} onPress={() => editAlbum(album.id)} pressDelay={PRESS_DELAY}>
        <Album
          album={album}
          info={getAlbumInfo(album)}
          getImageSource={getImageSource}
          favourite={isFavourite(album.id)}
          fixed={fixed}
        />
      </Tappable>
    )
  }
  render () {
    const { albums, moreLink, showCreateAlbum } = this.props
    return (
      <ul className={classNames.list}>
        {showCreateAlbum &&
          <li className={classNames.item}>
            <Link to='/search' className={classNames.addLink}>
              <Icon icon='plus' className={classNames.addLinkIcon} size={40} />
              <div className={classNames.title}>
                Create Album
              </div>
            </Link>
          </li>
        }
        {albums.slice(0, LIMIT_ALBUMS).map(this.renderAlbum)}
        {albums.length > LIMIT_ALBUMS &&
          <li className={classNames.item}>
            <Link to={moreLink} className={classNames.moreLink}>
              <div className={classNames.moreCount}>
                +{albums.length - LIMIT_ALBUMS}
              </div>
              <div className={classNames.moreText}>
                View more
              </div>
            </Link>
          </li>
        }
      </ul>
    )
  }
}

class Album extends Component {
  shouldComponentUpdate () {
    return false
  }
  render () {
    const { album, getImageSource, info, favourite, fixed } = this.props
    if (!album) {
      return null
    }
    const { name, id, cover } = album
    const style = { backgroundImage: `url(${getImageSource(cover)})` }
    return (
      <li className={classNames.item}>
        <Link to={`/album/${id}`} className={classNames.link} style={style}>
          <div className={fixed ? classNames.titleLocked : classNames.title}>
            {name}
            {info &&
              <div className={classNames.info}>{info}</div>
            }
          </div>
          <div className={classNames.icons}>
            {favourite &&
              <Icon icon='heart' size={18} />
            }
          </div>
          {fixed &&
            <Icon icon='lock' size={13} className={classNames.lock} />
          }
        </Link>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/album/AlbumList.js